import _ from "lodash";

// Whether we are runing on macOS or not.
export const IS_MAC = _.includes(
    window.navigator.platform.toLowerCase(),
    "mac"
);
